import { jobPhotoAPI } from '../services/api';

// nginx limits /api/ to 10 requests/s per IP and answers an instant 503 past
// the burst. A 503 or 429 is therefore "try again shortly", not "the photo is
// gone"; anything else fails at once.
export const RETRY_DELAYS_MS = [500, 1000, 2000, 4000];

const isRateLimited = (e) => {
  const s = e?.response?.status;
  return s === 503 || s === 429;
};

// Fetches a photo's bytes, retrying rate-limit responses with backoff.
// `token` is {cancelled: boolean}; set it (and call token.wake?.()) to stop.
export async function fetchPhotoBlob(jobId, photoId, token = { cancelled: false }) {
  for (let attempt = 0; ; attempt += 1) {
    try {
      return await jobPhotoAPI.getBlob(jobId, photoId);
    } catch (e) {
      if (!isRateLimited(e) || attempt >= RETRY_DELAYS_MS.length || token.cancelled) throw e;
      await new Promise((resolve) => {
        const t = setTimeout(resolve, RETRY_DELAYS_MS[attempt]);
        token.wake = () => { clearTimeout(t); resolve(); };
      });
      if (token.cancelled) throw e;
    }
  }
}
